import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Label } from "reactstrap";
import {
	AvForm,
	AvField,
	AvRadioGroup,
	AvRadio,
} from "availity-reactstrap-validation";
import Select from "react-select";
import FileUpload from "components/Common/file-upload/file-upload.component";
import Language from "Enums/Language";
import SelectOptions from "components/SelectOptions";
import FinishingTypesService from "services/Admin/FinishingTypesService";
import UnitTypesService from "services/Admin/UnitTypesService";
import CategoriesService from "services/Admin/CategoriesService";
import BuildingService from "services/Admin/BuildingService";
import PropertyService from "services/Admin/PropertyService";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { adminPrefix } from "configs/routePrefix";
// import { adminAmenitiesOptions } from "Enums/fixedData"
import CompoundService from "services/Admin/CompoundService";
import PaymentPlanService from "services/Admin/PaymentPlanService";
import PaymentPlan from "../PaymentPlan";
import CancelModal from "components/CancelModal";
import CurrencyInput from "react-currency-input-field";
import SuccessModal from "components/SucessModal";
import UnitSizesService from "services/Admin/UnitSizesService";
import { useSelector } from "react-redux";
import AmenitiesService from "services/Admin/AmenitiesService";
import FileUploadComponent from "components/Common/UploadImgCroped/file-upload.component";

const languages = ["en", "ar", "zh", "ru"];

const initialState = {
	amenities: [],
	en: "",
	ar: "",
	ru: "",
	zh: "",
	descrip_en: "",
	descrip_ar: "",
	descrip_zh: "",
	descrip_ru: "",
	price: "",
	unit_floor_num: "",
	bedRoom_num: "",
	bathroom_num: null,
	payment_method: {
		label: "Installment",
		value: "Installment",
	},
	selectedFinishingType: null,
	selectUnitType: null,
	selectedCatogory: null,
	selectedBulding: null,
	hasBasement: false,
	basementSize: "",
	hasRoof: false,
	roofSize: "",
	hasGarden: false,
	gardenSize: "",
	hasBool: false,
	boolSize: "",
	selectedCompound: null,
	hasMultiFloor: false,
	floorSize: "",
	payment_plans: [
		{
			id: null,
			year_id: null,
			// total: ""
		},
	],
	sale_status: "",
	sizes: [],
	total_built_up_area: "",
	built_up_area: "",
	construction_status: "",
	delivery_date: "",
	unit_code: "",
	title_before_number: "",
	title_number_from: "",
	title_number_to: "",
	// amenitiesOther: "",
};
const PropertyForm = (props) => {
	const id = props.id;
	const filterData = useSelector((state) => state.adminFilter);
	const compound_id =
		filterData.compound_id || localStorage.getItem("compound_id");
	const addProperty =
		filterData?.addProperty || localStorage.getItem("addProperty");
	const path = filterData?.path || localStorage.getItem("path");
	const building_id =
		filterData?.building_id || localStorage.getItem("building_id");
	const [uploadState, setUploadState] = useState(false);
	const [loading, setLoading] = useState(false);
	const buildingService = new BuildingService();
	const propertyService = new PropertyService();
	const paymentPlanService = new PaymentPlanService();
	const categoriesService = new CategoriesService();
	const amenitiesService = new AmenitiesService();
	const [amenitiesOptions, setAmenitiesOptions] = useState([]);
	const [loadAmenities, setLoadAmenities] = useState(false);
	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [modal, setModal] = useState(false);
	const [formData, setFormData] = useState({
		...initialState,
		// selectedCompound: !!filterData.compound_id ? {value: filterData.compound_id} : null
	});
	const [sizeTypeErrors, setSizeTypeErrors] = useState({});
	const [error, setError] = useState({
		unit_code: false,
		compound: false,
		built_up_area: false,
		err: [],
	});

	const [CompoundOpttions, setCompoundpttions] = useState([]);
	const [mainImgId, setMainImgId] = useState([]);
	const [mediaIds, setMediaIds] = useState([]);
	const [videosIds, setVideosIds] = useState([]);
	const [catogoryOptions, setCatogoryOptions] = useState([]);
	const [buildingOpttions, setBuildingOpttions] = useState([]);
	const [FinishingOptions, setFinishingOptions] = useState([]);
	const [unitTypeOptions, setUnitTypeOptions] = useState([]);
	const [unitSizesOptions, setUnitSizesOptions] = useState([]);
	const [paymentOptions, setPaymentOptions] = useState([]);
	const [yearsData, setYearsData] = useState([]);
	const [floorLimit, setFloorLimit] = useState(200);
	const unitSizesService = new UnitSizesService();
	const compoundService = new CompoundService();

	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	useEffect(() => {
		paymentPlanService.getDropDown(compound_id).then((res) => {
			const years = res.data.map((item) => {
				return {
					years: item.years,
					id: item.id,
				};
			});
			setYearsData(years);
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
				};
			});
			setPaymentOptions(newOptions);
		});
	}, [formData?.selectedCompound, formData?.payment_method]);

	const updatedAttachment = (attachments, type) => {
		if (type === "media_id") {
			setMediaIds([...mediaIds, ...attachments]);
		} else if (type === "main_img_id") {
			setMainImgId(attachments);
		} else {
			setVideosIds([...videosIds, ...attachments]);
		}
	};

	const deleteAttachment = (Items, type) => {
		if (type === "media_id") {
			let updatedMedia = mediaIds.filter((item) => item.id != Items[0].id);
			setMediaIds(updatedMedia);
		} else if (type === "main_img_id") {
			setMainImgId([]);
		} else {
			let updatedMedia = mediaIds.filter((item) => item.id != Items[0].id);
			setVideosIds(updatedMedia);
		}
	};

	useEffect(() => {
		if (props?.CompoundData?.value) {
			setFormData({ ...formData, selectedCompound: props.CompoundData });
		}
		if (id) {
			propertyService.find(id).then((response) => {
				if (response && response.status === SuccessOk) {
					const sizesData = response.data.sizes?.map((item) => {
						setUnitSizesOptions(
							unitSizesOptions?.filter((option) => option.label !== item.label)
						);
						return {
							label: { label: item.label },
							value: `${item?.value}`,
						};
					});
					const date = !!response?.data?.delivery_date
						? response?.data?.delivery_date?.split("-")[0] +
						  "-" +
						  response?.data?.delivery_date?.split("-")[1]
						: "";
					// let newAmenities= !!response.data?.amenities_ids ? response.data?.amenities_ids?.filter(({label: id1}) => adminAmenitiesOptions.some(({label: id2})=> id1 === id2 )) : []
					// let newAmenitiesOther = [] //!!response.data?.amenities ? response.data?.amenities?.filter(({label: id1}) => !adminAmenitiesOptions.some(({label: id2})=> id1 === id2 )) : []

					setFormData({
						...formData,
						amenities: !!response.data?.amenities?.length
							? response.data?.amenities?.map((ame) => {
									return {
										label: ame?.name?.en,
										value: ame?.id,
										id: ame?.id,
									};
							  })
							: [],
						// amenitiesOther: {...newAmenitiesOther[0]},
						unit_code: response.data.name?.en,
						descrip_ar: response.data.description.ar,
						descrip_en: response.data.description.en,
						descrip_ru: response.data.description.ru,
						descrip_zh: response.data.description.zh,
						sale_status: response.data.sale_status,
						built_up_area: response.data?.size,
						price: response.data.price,
						unit_floor_num: response.data.floor,
						bedRoom_num: response.data.bedrooms,
						bathroom_num: response.data.bathrooms,
						selectedFinishingType: !!response.data?.finishing_type?.name
							? {
									label: response.data.finishing_type.name,
									value: response.data.finishing_type.id,
							  }
							: null,
						selectUnitType: !!response.data?.unit_type?.name
							? {
									label: response.data.unit_type.name,
									value: response.data.unit_type.id,
							  }
							: null,
						selectedCatogory: !!response.data?.category?.name
							? {
									label: response.data.category.name,
									value: response.data.category.id,
							  }
							: null,

						selectedCompound: {
							label: response.data.coumound.name,
							value: response.data.coumound.id,
						},
						selectedBulding: response.data.building?.id
							? {
									label: response.data.building?.name,
									value: response.data.building?.id,
							  }
							: null,
						sizes: !!sizesData ? sizesData : [],
						construction_status: response?.data?.construction_status,
						delivery_date: date,
					});

					// if (response.data.building) {
					//     setFormData((formData) => {
					//         return {
					//             ...formData,
					//             selectedBulding: {
					//                 label: response.data.building.name,
					//                 value: response.data.building.id
					//             }
					//         }
					//     })
					// }

					const payment_plans = !!response?.data?.payment_plans?.length
						? response.data.payment_plans.map((item) => {
								return {
									id: {
										label: item.payment_paln.name.en,
										value: item.payment_paln.id,
									},
									year_id: {
										label: item.year.year,
										value: item.year.id,
									},
									// total: item.total
								};
						  })
						: [
								{
									id: null,
									year_id: null,
								},
						  ];
					// response.data.options?.forEach(item => {
					//     if (item.name === 'bool') {
					//         setFormData((formData) => ({
					//             ...formData,
					//             hasBool: true,
					//             boolSize: item.area
					//         }))
					//     } else if (item.name === "roof") {
					//         setFormData((formData) => ({
					//             ...formData,
					//             hasRoof: true,
					//             roofSize: item.area
					//         }))
					//     }
					//     else if (item.name === "garden") {
					//         setFormData((formData) => ({
					//             ...formData,
					//             hasGarden: true,
					//             gardenSize: item.area
					//         }))
					//     }
					//     else if (item.name === "basement") {
					//         setFormData((formData) => ({
					//             ...formData,
					//             hasBasement: true,
					//             basementSize: item.area
					//         }))
					//     }
					//     else {
					//         setFormData((formData) => ({
					//             ...formData,
					//             hasMultiFloor: true,
					//             floorSize: item.area
					//         }))
					//     }
					// })
					setFormData((formData) => ({
						...formData,
						payment_plans: payment_plans,
					}));
					setMainImgId([response.data.main_image]);
					setMediaIds(response.data.images);
					setVideosIds(response.data.videos);
				}
			});
		}
	}, [loadAmenities]);

	useEffect(() => {
		buildingService.getDropDown(compound_id).then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
					floors_num: item.floors_num,
				};
			});
			setBuildingOpttions(newOptions);
		});
		amenitiesService.getList({ status: 1 }).then((res) => {
			const newOptions = res.data?.data?.map((item) => {
				return {
					...item.name,
					label: item.name.en,
					value: item.id,
				};
			});
			setAmenitiesOptions([...newOptions]);
			setLoadAmenities(true);
		});
	}, []);

	useEffect(() => {
		if (buildingOpttions?.length && formData?.selectedBulding) {
			const limit = buildingOpttions.find(
				(option) => option?.value === formData?.selectedBulding?.value
			);
			if (limit) setFloorLimit(limit.floors_num);
		}
	}, [buildingOpttions, formData?.selectedBulding]);

	useEffect(() => {
		unitSizesService.getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en ? item.name.en : item.name,
					value: item.id,
				};
			});
			setUnitSizesOptions(newOptions);
		});

		compoundService.getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en ? item.name.en : item.name,
					value: item.id,
				};
			});
			setCompoundpttions(newOptions);
		});
	}, []);

	useEffect(() => {
		const id = formData?.selectedBulding?.value;
		categoriesService.getDropDown(id).then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en ? item.name.en : item.name,
					value: item.id,
				};
			});
			setCatogoryOptions(newOptions);
		});
	}, [formData?.selectedBulding]);

	const CheckpaymentCompleted = () => {
		let value = false;
		if (formData?.payment_method.value === "Cash") {
			return false;
		} else {
			formData?.payment_plans.forEach((plan, index) => {
				for (let key in plan) {
					if (key === "id" || key === "year_id") {
						if (!plan[key]) {
							toast.error(
								`complete the payment plan data number (${index + 1})`
							);
							value = true;
							return;
						}
					}
					// else if (key === "total" && (plan[key] === "" || plan[key] === 0)) {
					//     toast.error(`Total Price is required and shall be greater than zero  in payment number (${index + 1})`)
					//     value = true
					//     return
					// }
				}
			});
		}
		return value;
	};

	const handleValidSubmit = () => {
		// if (!formData?.price || formData?.price === "0" || !formData?.price) {
		//     toast.error(" Price is required and shall be greater than zero ")
		//     return
		// }
		// if(formData?.sizes?.length > 0){
		//     formData?.sizes?.map((size, index)=> {
		//         if(!size?.label){
		//             setSizeTypeErrors((prev)=> ({...prev, [index]: true}))
		//         }
		//     })
		// }
		// if (formData?.sizes?.filter(size=> !size.label).length > 0){
		//     return
		// }
		// if (!formData?.selectedCompound ||

		//     !formData?.price ||
		//     !formData?.payment_method ||
		//     !formData?.selectedCatogory ||
		//     !formData?.selectedFinishingType ||
		//     !formData?.selectUnitType
		// ) {
		//     toast.error("please complete the form data")
		//     return
		// }
		// if (CheckpaymentCompleted()) {
		//     return
		// } else

		let check = false;
		let err = [];
		formData?.sizes?.map((size, index) => {
			let test = {};
			if (!size.label) {
				test["label"] = true;
			}
			if (!size.value) {
				test["value"] = true;
			}
			if (test["value"] || test["label"]) {
				err.push({ index: index, ...test });
				check = true;
			}
		});
		if (
			(!formData?.unit_code && filterData?.addProperty == "property") ||
			!formData?.built_up_area ||
			check
		) {
			let errors = {};
			if (!formData?.unit_code && filterData?.addProperty == "property") {
				errors["unit_code"] = true;
			}
			// if(!formData?.selectedCompound ){
			//     errors['compound'] = true
			// }
			if (!formData?.built_up_area) {
				errors["built_up_area"] = true;
			}

			setError({ ...error, ...errors, err });
			return;
		} else {
			let options = [];
			// if (formData?.hasBasement) options.push({ name: "basement", area: parseInt(formData?.basementSize) })
			// if (formData?.hasRoof) options.push({ name: "roof", area: parseInt(formData?.roofSize) })
			// if (formData?.hasGarden) options.push({ name: "garden", area: parseInt(formData?.gardenSize) })
			// if (formData?.hasBool) options.push({ name: "bool", area: parseInt(formData?.boolSize) })
			// if (formData?.hasMultiFloor) options.push({ name: "doblex", area: parseInt(formData?.floorSize) })
			if (!mainImgId?.length) {
				toast.error("Upload Main Image");
				return;
			}
			setLoading(true);
			const sizesData = formData?.sizes?.map((item) => {
				return {
					label: item?.label?.label,
					value: parseInt(item?.value),
				};
			});
			const data = {
				size: !!formData?.built_up_area
					? parseInt(formData?.built_up_area)
					: "",
				compound_id: compound_id,
				description: {},
				sale_status: props.id ? formData?.sale_status : "Left",
				floor: !!formData?.unit_floor_num ? formData?.unit_floor_num : "",
				price: !!formData?.price ? formData?.price : "",
				bedrooms: !!formData?.bedRoom_num ? formData?.bedRoom_num : "",
				bathrooms: !!formData?.bathroom_num ? formData?.bathroom_num : "",
				payment_method: formData?.payment_method?.value,
				category_id: formData?.selectedCatogory?.value,
				finishing_type_id: formData?.selectedFinishingType?.value,
				unit_type_id: formData?.selectUnitType?.value,
				images_ids:
					mediaIds?.length > 0 ? [...mediaIds]?.map((item) => item.id) : [],
				main_image: mainImgId[0]?.id,
				videos_ids:
					videosIds?.length > 0 ? [...videosIds]?.map((item) => item.id) : [],
				construction_status: !!formData?.construction_status
					? formData?.construction_status
					: "",
				delivery_date: !!formData?.delivery_date
					? `${formData?.delivery_date}-01`
					: "",
			};
			if (addProperty == "property") data["name"] = { en: formData?.unit_code };
			if (addProperty == "properties") {
				data["name"] = { en: formData.title_before_number };
				data["title_number_from"] = formData.title_number_from;
				data["title_number_to"] = formData.title_number_to;
			}
			if (formData?.sizes?.length > 0) data["sizes"] = sizesData;
			if (options?.length > 0) data["options"] = options;

			// if(!!formData?.amenitiesOther.label || formData.amenities?.length > 0){
			//     let newAmenities= formData.amenities?.filter(item => item.label !== "Other")
			//     data["amenities"] = [...newAmenities,!!formData?.amenitiesOther.label && formData?.amenitiesOther]
			// }
			data["amenities_ids"] =
				formData?.amenities?.map((item) => item?.value) || [];
			if (!!formData?.selectedBulding?.label)
				data["building_id"] = formData?.selectedBulding?.value;
			if (path === "PropertiesInBuilding") data["building_id"] = building_id;
			if (path === "toStandaloneProperties") data["building_id"] = null;
			if (path === "allProperties")
				data["building_id"] = !!formData.selectedBulding?.label
					? formData.selectedBulding?.value
					: null;

			languages.forEach((language) => {
				if (formData[`descrip_${language}`]?.length) {
					data.description[language] = formData[`descrip_${language}`];
				}
			});

			if (
				formData?.payment_plans?.length > 0 &&
				!!formData?.payment_plans[0]?.id
			) {
				data["payment_plans"] = formData?.payment_plans?.map((plan) => {
					return {
						id: plan?.id?.value,
						year_id: plan?.year_id?.value,
						// total: plan ?.total
					};
				});
			} else {
				data["payment_plans"] = [];
			}

			if (props.id) {
				propertyService
					.update(props.id, data)
					.then((response) => {
						if (response && response.status === SuccessOk) {
							// toast.success("Property has been updated")
							setShowSuccessModal(true);
							// props.history.push(`${adminPrefix}/Admin-developer/property`)
						} else {
							setLoading(false);
						}
					})
					.catch(() => setLoading(false));
			} else {
				propertyService
					.create(data)
					.then((response) => {
						if (response && response.status === SuccessCreated) {
							setLoading(false);
							setShowSuccessModal(true);
							// toast.success("New Property has been added")
						} else {
							setLoading(false);
						}
					})
					.catch(() => setLoading(false));
			}
		}
	};

	return (
		<AvForm
			className="form-horizontal"
			onValidSubmit={(e, v) => handleValidSubmit()}>
			<Card className="mt-3">
				<CardBody>
					<Row>
						{addProperty == "property" && (
							<Col md={6} className="mb-3">
								<label className={`${error.unit_code && "error-text"}`}>
									Unit Code (required)
								</label>
								<AvField
									name="unit_code"
									bsSize="lg"
									value={formData.unit_code}
									onChange={(e) => {
										handleFieldChange(e);
										setError({ ...error, unit_code: false });
									}}
									placeholder={"Unit Code"}
									// validate={{
									//     pattern: {value: '/^[a-zA-Z0-9 ]+$/', errorMessage: `Unit Code Format is invalid`}
									// }}
								/>
								{error.unit_code && (
									<span className="error-text font-size-11">
										This Field is required
									</span>
								)}
							</Col>
						)}
						{addProperty == "properties" && (
							<>
								<Col md={6} className="mb-3">
									<label>Title before number (optional)</label>
									<AvField
										name="title_before_number"
										bsSize="lg"
										value={formData.title_before_number}
										onChange={(e) => {
											handleFieldChange(e);
										}}
										placeholder={"Title before number"}
										// validate={{
										//     pattern: {
										//         value: /^(?!.*-$)[a-zA-Z0-9 %!@#$%^&*()_+=~`{}|:;"'<>,.?/\\[\]-]*$/,
										//         errorMessage: `this format is invalid`
										//     }
										// }}
									/>
								</Col>
								<Col md={3} className="mb-3">
									<AvField
										name={"title_number_from"}
										label={"From (Required)"}
										bsSize="lg"
										value={formData?.title_number_from}
										required
										errorMessage={"This field is required"}
										onChange={(e) => handleFieldChange(e)}
										validate={{
											pattern: {
												value: "/^[0-9]+$/",
												errorMessage: "This field is invalid!",
											},
										}}
										placeholder={"Start From"}
										type="number"
										min={"0"}
										max={formData?.title_number_to}
									/>
								</Col>
								<Col md={3} className="mb-3">
									<AvField
										name={"title_number_to"}
										label={"To (Required)"}
										bsSize="lg"
										value={formData?.title_number_to}
										onChange={(e) => handleFieldChange(e)}
										required
										validate={{
											pattern: {
												value: "/^[0-9]+$/",
												errorMessage: "This field is invalid!",
											},
										}}
										errorMessage={"This field is required"}
										placeholder={"End To"}
										type="number"
										pattern="/^[0-9]+$/"
										min={formData.title_number_from}
										// max={floorLimit}
									/>
								</Col>
							</>
						)}
						{!compound_id ? (
							<Col md={6} className="mb-3">
								<label className={`${error.compound && "error-text"}`}>
									Compound (required)
								</label>
								<Select
									placeholder="Select"
									options={CompoundOpttions}
									style={{ borderColor: "red" }}
									onChange={(data) => {
										setError({ ...error, compound: false });
										setFormData({
											...formData,
											selectedCompound: data,
											selectedBulding: null,
											selectedCatogory: null,
										});
									}}
									value={formData?.selectedCompound}
									setOptions={(options) => setCompoundpttions(options)}
								/>
								{error.compound && (
									<span className="error-text font-size-11 mb-3">
										This Field is required
									</span>
								)}
							</Col>
						) : null}

						{(path == "allProperties" || path == "fromCompound") && (
							<Col md={6}>
								<label>Building</label>
								<Select
									placeholder="Select"
									options={buildingOpttions}
									className="mb-3 "
									onChange={(data) => {
										setFormData({
											...formData,
											selectedBulding: data,
											selectedCatogory: null,
										});
									}}
									value={formData?.selectedBulding}
									setOptions={(options) => setBuildingOpttions(options)}
								/>
							</Col>
						)}
						{addProperty == "property" && (
							<Col md={6} className="mb-3">
								<AvField
									name={"unit_floor_num"}
									label={`${
										path == "PropertiesInBuilding" ||
										!!formData?.selectedBulding?.label
											? "Floor Number"
											: "Number of Floors"
									}`}
									bsSize="lg"
									value={formData?.unit_floor_num}
									onChange={(e) => handleFieldChange(e)}
									// required
									// errorMessage={formData?.unit_floor_num==="" ?  "This field is required" :"This field is invalid!"}
									placeholder={`${
										path == "PropertiesInBuilding" ||
										!!formData?.selectedBulding?.label
											? "Floor Number"
											: "Number of Floors"
									}`}
									type="number"
									pattern="/^[0-9]+$/"
									min={"0"}
									max={floorLimit}
								/>
							</Col>
						)}
						{/* <Col md={6}>
                            <SelectOptions
                                label='Category'
                                placeholder='Select'
                                options={catogoryOptions}
                                handleSelectChange={data => setFormData({ ...formData, selectedCatogory: data })}
                                selectedOption={formData?.selectedCatogory}
                                Service={CategoriesService}
                                setOptions={options => setCatogoryOptions(options)}
                            />
                        </Col> */}

						<Col md={6}>
							<label>Category</label>
							<Select
								placeholder="Select"
								options={catogoryOptions}
								className="mb-3 "
								onChange={(data) =>
									setFormData({ ...formData, selectedCatogory: data })
								}
								value={formData?.selectedCatogory}
								setOptions={(options) => setCatogoryOptions(options)}
							/>
						</Col>
						<Col md={6} className="mb-3">
							<AvField
								name={"bedRoom_num"}
								label={"No. Of Bedrooms"}
								bsSize="lg"
								value={formData?.bedRoom_num}
								onChange={(e) => handleFieldChange(e)}
								// required
								// errorMessage="This field is required"
								placeholder={"bedroom Number"}
								type="number"
								pattern="/^[0-9]+$/"
								min={"1"}
								max={"20"}
							/>
						</Col>
						<Col md={6} className="mb-3">
							<AvField
								name={"bathroom_num"}
								label={"No. Of Bathroom"}
								bsSize="lg"
								value={formData?.bathroom_num}
								onChange={(e) => handleFieldChange(e)}
								// required
								// errorMessage="This field is required"
								placeholder={"bathroom Number"}
								pattern="/^[0-9]+$/"
								type="number"
								min={"1"}
								max={"20"}
							/>
						</Col>
						<Col md={6}>
							<SelectOptions
								label="Finishing"
								placeholder="Select"
								options={FinishingOptions}
								handleSelectChange={(data) =>
									setFormData({ ...formData, selectedFinishingType: data })
								}
								selectedOption={formData?.selectedFinishingType}
								Service={FinishingTypesService}
								setOptions={(options) => setFinishingOptions(options)}
							/>
						</Col>

						<Col md={6}>
							<SelectOptions
								label="Unit Type"
								placeholder="Select"
								options={unitTypeOptions}
								handleSelectChange={(data) =>
									setFormData({ ...formData, selectUnitType: data })
								}
								selectedOption={formData?.selectUnitType}
								Service={UnitTypesService}
								setOptions={(options) => setUnitTypeOptions(options)}
							/>
						</Col>
						<Col md={6} className="mb-3">
							<AvField
								name={"construction_status"}
								label={"Development Status"}
								bsSize="lg"
								// required
								value={formData?.construction_status}
								onChange={(e) => handleFieldChange(e)}
								placeholder={"Development Status"}
								type="text"
								// errorMessage="This field is required"
							/>
						</Col>
						<Col md={6}>
							<AvField
								className="mb-3"
								name={"delivery_date"}
								label={"Development Date"}
								bsSize="lg"
								value={formData?.delivery_date}
								onChange={(e) => handleFieldChange(e)}
								placeholder={"Development Date"}
								type="month"
							/>
						</Col>
						<Col md={6} className="price-input">
							<Label>Price</Label>
							<CurrencyInput
								id="price"
								className="mb-3"
								name="price"
								placeholder="price"
								value={formData?.price}
								allowNegativeValue={false}
								decimalsLimit={2}
								onValueChange={(value, name) => {
									setFormData({ ...formData, price: value });
								}}
							/>
						</Col>
						{props.id ? (
							<Row className="mb-4">
								<Label>Sale Status</Label>
								<Col md={6}>
									<AvRadioGroup
										required
										inline
										name="sale_status"
										value={formData?.sale_status}
										onChange={handleFieldChange}>
										<AvRadio label="Left" value="Left" />
										<AvRadio label="Bought" value="Bought" />
									</AvRadioGroup>
								</Col>
							</Row>
						) : null}
						{/* <Row className="mb-1">
                            <h4>Desctiption</h4>
                        </Row> */}
						{Language.LIST.map((lan, index) => {
							return (
								<Col md={12} key={index}>
									<AvField
										className="mb-3"
										name={lan.descrip_name}
										label={`Description (${lan.name})`}
										bsSize="lg"
										value={formData[`${lan.descrip_name}`]}
										onChange={(e) => handleFieldChange(e)}
										// required={false}
										type="textarea"
										placeholder={
											lan.name === "en"
												? "English"
												: lan.name === "ar"
												? "العربية"
												: lan.name === "zh"
												? "中文"
												: "Русский"
										}
									/>
								</Col>
							);
						})}
					</Row>
				</CardBody>
			</Card>
			<Card className="my-4">
				<CardBody>
					<Row className="">
						<h5>Unit Areas</h5>
						<Col md={6} className="mt-2">
							<Label className={`${error.built_up_area && "error-text"}`}>
								Total Builtup Area (Required)
							</Label>
							<AvField
								name="built_up_area"
								bsSize="lg"
								// required
								onChange={(e) => {
									setError({ ...error, built_up_area: false });
									setFormData({ ...formData, built_up_area: e.target?.value });
								}}
								type="number"
								value={formData?.built_up_area}
								placeholder={"Total Builtup Area"}
								// validate={{
								//     required: {value: error.built_up_area, errorMessage: 'This Field is required'}
								// }}
							/>
							{error.built_up_area && (
								<span className="error-text font-size-11 mb-3">
									This Field is required
								</span>
							)}
						</Col>
						<Col md={6}></Col>
						{formData?.sizes?.length > 0 &&
							formData?.sizes?.map((size, index) => {
								return (
									<Row key={index}>
										<Col md={6} className="mt-3">
											<Label
												className={`${
													error?.err[`${index}`]?.value && "error-text"
												}`}>
												{!!size.label ? size?.label?.label : "Location"}
											</Label>
											<AvField
												name={`size${index}`}
												bsSize="lg"
												onChange={(e) => {
													const value = e.target?.value;
													const updatedSizes = formData?.sizes?.map(
														(sizeItem, sizeIndex) => {
															if (index === sizeIndex) {
																return {
																	...sizeItem,
																	value: value,
																};
															}
															return sizeItem;
														}
													);
													setFormData({
														...formData,
														sizes: [...updatedSizes],
													});
													const updatedError = error?.err?.map(
														(errItem, errIndex) => {
															if (index === errIndex) {
																return {
																	...errItem,
																	value: false,
																};
															}
															return errItem;
														}
													);
													setError({ ...error, err: [...updatedError] });
												}}
												type="number"
												value={size?.value}
												placeholder={"Location"}
											/>
											{error?.err[`${index}`]?.value && (
												<span className="error-text font-size-11 mb-3">
													This Field is required
												</span>
											)}
										</Col>
										<Col md={5} className="mt-3">
											<Label
												className={`${
													error?.err[`${index}`]?.label && "error-text"
												}`}>
												Area Type
											</Label>

											<Select
												placeholder="Select"
												options={unitSizesOptions}
												// required
												onChange={(e) => {
													const value = e;
													const updatedSizes = formData?.sizes?.map(
														(sizeItem, sizeIndex) => {
															if (index === sizeIndex) {
																return {
																	...sizeItem,
																	label: value,
																};
															}
															return sizeItem;
														}
													);
													setFormData({
														...formData,
														sizes: [...updatedSizes],
													});
													setUnitSizesOptions(
														unitSizesOptions.filter(
															(option) => e?.value !== option?.value
														)
													);
													const updatedError = error?.err?.map(
														(errItem, errIndex) => {
															if (index === errIndex) {
																return {
																	...errItem,
																	label: false,
																};
															}
															return errItem;
														}
													);
													setError({ ...error, err: [...updatedError] });
												}}
												value={size.label}
											/>
											{/* {sizeTypeErrors[index] && <p className="error mt-1">This field is required</p>} */}
											{error?.err[index]?.label && (
												<span className="error-text font-size-11 mb-3">
													This Field is required
												</span>
											)}
										</Col>
										<Col md={1} className="d-flex justify-content-end my-2">
											<button
												className="btn btn-light"
												type="button"
												onClick={() => {
													!!size?.label &&
														setUnitSizesOptions([
															...unitSizesOptions,
															size.label,
														]);
													const updatedSizes = formData?.sizes.filter(
														(_, ind) => ind !== index
													);
													setFormData({
														...formData,
														sizes: [...updatedSizes],
													});
												}}
												style={{
													color: "red",
													fontWeight: "700",
													height: "min-content",
													margin: "50% auto 0",
												}}>
												X
											</button>
										</Col>
									</Row>
								);
							})}

						<Col md={12} className="mt-3">
							<button
								type="button"
								className="btn btn-success"
								onClick={() =>
									setFormData({
										...formData,
										sizes: [
											...formData?.sizes,
											{
												label: null,
												value: "",
											},
										],
									})
								}>
								Add New Additional Area
							</button>
						</Col>
					</Row>
				</CardBody>
			</Card>
			{!!id && (
				<Card className="my-4">
					<CardBody>
						{formData?.payment_plans?.map((plan, index) => {
							return (
								<PaymentPlan
									compound={formData?.selectedCompound}
									key={index}
									payment_plans={formData?.payment_plans}
									index={index}
									formData={formData}
									paymentPlanOptionsData={paymentOptions}
									setPaymentOptions={setPaymentOptions}
									yearsData={yearsData}
									setFormData={setFormData}
								/>
							);
						})}
						<Row>
							{
								<Col md={12} className="d-flex flex-lg-row-reverse">
									<button
										className="add-Pay text-success font-size-16"
										type="button"
										onClick={() => {
											const updated = {
												...formData,
												payment_plans: [
													...formData?.payment_plans,
													{
														id: null,
														year_id: null,
													},
												],
											};
											setFormData({ ...updated });
										}}
										style={{ background: "none", border: "none" }}>
										<i className="fas fa-plus-circle"></i>&nbsp;Add Another
										Payment Year
									</button>
								</Col>
							}
						</Row>
					</CardBody>
				</Card>
			)}
			{/* {UnitOptions.LIST.map((option, index) => {
                return (
                    <Card key={index} >
                        <CardBody>
                            <Row className="mb-4">
                                <Col><h6>{option.label}</h6></Col>
                                <Col className="d-flex flex-row-reverse">
                                    <div className='form-check form-switch form-switch-md mb-1'>
                                        <AvField
                                            name={option.has}
                                            checked={formData[`${option.has}`]}
                                            value={formData[`${option.has}`]}
                                            type='checkbox'
                                            className='form-check-input'
                                            id='has_status'
                                            onChange={e => setFormData({ ...formData, [e.target.name]: e.target.checked })}
                                            // required={formData[`${option.has}`] ? true : false}
                                            // errorMessage="This field is required"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            {formData[`${option.has}`] &&
                                <Row>
                                    <Col md={6} >
                                        <AvField
                                            className="mb-3"
                                            name={`${option.size}`}
                                            label={"Size"}
                                            bsSize="lg"
                                            value={formData[`${option.size}`]}
                                            onChange={(e => handleFieldChange(e))}
                                            // required
                                            placeholder={option.placeholder}
                                            type="number"
                                            min={"1"}
                                            // errorMessage="This field is required"
                                        />
                                    </Col>
                                </Row>}
                        </CardBody>
                    </Card >
                )
            })
            } */}
			<Card>
				<CardBody>
					<Col md={6}>
						<label>Amenities</label>
						<Select
							label="Compound "
							placeholder="Select"
							options={[...amenitiesOptions]}
							className="mb-3 "
							onChange={(data) => {
								setFormData({ ...formData, amenities: data });
							}}
							value={formData.amenities}
							isMulti={true}
						/>
					</Col>
					{/* {!!formData?.amenities?.length && (formData.amenities.find(item => item.label === "Other") || !!formData?.amenitiesOther?.label) && <Col md={12}  >
                        <AvField
                            className="mb-0"
                            type="textarea"
                            label="Amenities Name"
                            name={"amenitiesOther"}
                            bsSize="lg"
                            value={formData?.amenitiesOther?.label}
                            minLength={formData?.amenitiesOther?.label === "" ? 1 : 2}
                            onChange={e => setFormData({...formData, amenitiesOther: {
                                value: e.target.value,
                                label: e.target.value,
                                en: e.target.value,
                            }})}
                            required
                            errorMessage="This field is required"
                            placeholder={'Amenities Name'}
                        />
                    </Col>} */}
				</CardBody>
			</Card>
			<Card>
				<CardBody>
					<Row>
						<Col md={12}>
							{/* <FileUpload
                                accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                label='Main Image'
                                attachmentType='main_img_id'
                                setUpload={()=> {}}
                                attachmentData={mainImgId}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                multiple
                                setUploadState={setUploadState}
                            /> */}
							<FileUploadComponent
								accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
								label="Main Image"
								attachmentType="main_img_id"
								setUpload={() => {}}
								attachmentData={mainImgId}
								updatedAttachment={updatedAttachment}
								deleteAttachment={deleteAttachment}
								setUploadState={setUploadState}
								ratio={{ x: 661.5, y: 398 }}
							/>
						</Col>
					</Row>
				</CardBody>
			</Card>
			<Card>
				<CardBody>
					<Row>
						<Col md={12}>
							<FileUpload
								accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
								label="Property Images"
								attachmentType="media_id"
								setUpload={() => {}}
								attachmentData={mediaIds}
								updatedAttachment={updatedAttachment}
								deleteAttachment={deleteAttachment}
								setUploadState={setUploadState}
								multiple
							/>
						</Col>
					</Row>
				</CardBody>
			</Card>
			<Card>
				<CardBody>
					<Row>
						<Col md={12}>
							<FileUpload
								accept=".mp4"
								label="Property Videos"
								attachmentType="videos_id"
								setUpload={() => {}}
								attachmentData={videosIds}
								updatedAttachment={updatedAttachment}
								deleteAttachment={deleteAttachment}
								multiple
								setUploadState={setUploadState}
							/>
						</Col>
					</Row>
				</CardBody>
			</Card>
			<Row className="mb-4 d-flex">
				<Col md={6}>
					<button
						type="button"
						onClick={() => setModal(true)}
						className="btn btnHeight btn-light">
						Cancel
					</button>
				</Col>
				<Col md={6} className=" d-flex flex-row-reverse">
					<Button
						type="submit"
						className="btn btn-success btnHeight"
						disabled={uploadState ? true : loading ? true : false}>
						Submit
					</Button>
				</Col>
			</Row>
			<CancelModal
				modal={modal}
				setModal={setModal}
				goBackHandler={() => {
					if (filterData.path == "fromCompound") {
						props.history.push(
							`${adminPrefix}/Admin-developer/compound-list/${filterData.developer_id}`
						);
					} else {
						props.history.push(`${adminPrefix}/Admin-developer/property`);
					}
				}}
			/>

			{showSuccessModal && (
				<SuccessModal
					modal={showSuccessModal}
					title={props.id ? "Edit Property" : "Add Property"}
					subtitle={""}
					message={
						props.id
							? "Property Edited Successfully"
							: "Property Added Successfully"
					}
					onClick={() => {
						if (filterData.path == "fromCompound") {
							props.history.push(
								`${adminPrefix}/Admin-developer/compound-list/${filterData.developer_id}`
							);
						} else {
							props.history.push(`${adminPrefix}/Admin-developer/property`);
						}
					}}
				/>
			)}
		</AvForm>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default PropertyForm;
